function NRPyPiIcon({ height = '24', width = '24' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.1941 16.6497V20.6705L16.6659 19.407V15.386L13.1941 16.6497Z"
        fill="#FFD242"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M16.0367 17.6299C16.0367 17.7231 16.0195 17.8217 15.986 17.92C15.9525 18.0183 15.9034 18.1144 15.8414 18.2028C15.7795 18.2913 15.706 18.3703 15.6251 18.4354C15.5442 18.5005 15.4574 18.5504 15.3699 18.5822C15.1931 18.6465 15.0236 18.6335 14.8986 18.5459C14.7736 18.4584 14.7033 18.3036 14.7032 18.1155C14.7032 18.0224 14.7204 17.9238 14.7539 17.8255C14.7874 17.7272 14.8365 17.6311 14.8984 17.5427C14.9603 17.4543 15.0338 17.3752 15.1147 17.3101C15.1956 17.245 15.2823 17.1951 15.3699 17.1632C15.4574 17.1314 15.5441 17.1181 15.625 17.1244C15.7059 17.1306 15.7795 17.1561 15.8414 17.1994C15.9033 17.2428 15.9524 17.3032 15.9859 17.3771C16.0194 17.451 16.0367 17.537 16.0367 17.6301V17.6299Z"
        fill="white"
      />
      <path
        d="M9.75812 17.8991V21.9201L13.2299 20.6564V16.6354L9.75812 17.8991Z"
        fill="#FFD242"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M6.29895 16.6392L9.7202 17.8844V21.9054L6.29895 20.6602V16.6392Z"
        fill="#EFEEEA"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M16.6302 11.3394V15.3602L20.1019 14.0967V10.0757L16.6302 11.3394Z"
        fill="#FFD242"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M13.209 6.03341L16.6303 7.27866L20.1019 6.01493L16.6809 4.76968L13.209 6.03341Z"
        fill="#FFC91D"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M16.6303 7.27865V11.2994L20.1019 10.0359V6.01492L16.6303 7.27865ZM13.1941 12.5889V16.6097L16.6659 15.3462V11.3252L13.1941 12.5889Z"
        fill="#FFD242"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M13.1941 8.52807V12.5488L16.6659 11.2853V7.26434L13.1941 8.52807Z"
        fill="#3775A9"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M9.77301 3.22203L13.194 4.46728L16.6659 3.20356L13.2448 1.95853L9.77301 3.22203Z"
        fill="#2F6491"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M13.1941 4.46705V8.48805L16.6659 7.22455V3.20355L13.1941 4.46705Z"
        fill="#3775A9"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M9.75812 13.8383V17.8593L13.2299 16.5956V12.5746L9.75812 13.8383Z"
        fill="#FFD242"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M9.75806 9.77749V13.7985L13.2299 12.5348V8.51376L9.75806 9.77749ZM6.32208 15.0877V19.1087L9.79369 17.845V13.8242L6.32208 15.0877Z"
        fill="#3775A9"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M2.90088 13.8427L6.32212 15.0877V19.1087L2.90088 17.8635V13.8427ZM2.90088 9.78169L6.32212 11.0269L9.79373 9.76344L6.37271 8.51819L2.90088 9.78169Z"
        fill="#2F6491"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M6.32208 11.0269V15.0479L9.79369 13.7842V9.76343L6.32208 11.0269Z"
        fill="#3775A9"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M2.90088 9.78168L6.32212 11.0269V15.0479L2.90088 13.8027V9.78168ZM6.33708 4.47145L9.75811 5.7167L13.2299 4.45298L9.80869 3.20795L6.33708 4.47145Z"
        fill="#2F6491"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M9.75812 5.71669V9.73769L13.2299 8.47397V4.45297L9.75812 5.71669Z"
        fill="#3775A9"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M6.33704 4.47144L9.75806 5.71668V9.73768L6.33704 8.49243V4.47144Z"
        fill="#2F6491"
        stroke="#CCCCCC"
        strokeWidth="0.378666"
        strokeLinejoin="bevel"
      />
      <path
        d="M11.721 7.00813C11.721 7.10132 11.7038 7.19988 11.6703 7.29818C11.6368 7.39648 11.5877 7.49259 11.5257 7.58103C11.4638 7.66946 11.3903 7.74848 11.3094 7.81358C11.2285 7.87868 11.1417 7.92858 11.0542 7.96043C10.9666 7.99231 10.8799 8.00551 10.799 7.9993C10.7181 7.99308 10.6446 7.96757 10.5826 7.92421C10.5207 7.88086 10.4716 7.8205 10.4381 7.7466C10.4046 7.6727 10.3873 7.58671 10.3873 7.49352C10.3873 7.40033 10.4045 7.30177 10.438 7.20347C10.4715 7.10517 10.5207 7.00906 10.5826 6.92062C10.6445 6.83219 10.718 6.75316 10.7989 6.68807C10.8799 6.62297 10.9666 6.57307 11.0542 6.54122C11.1417 6.50934 11.2284 6.49613 11.3093 6.50235C11.3902 6.50856 11.4638 6.53408 11.5257 6.57744C11.5876 6.62079 11.6367 6.68115 11.6702 6.75505C11.7037 6.82894 11.721 6.91494 11.721 7.00813V7.00813Z"
        fill="white"
      />
    </svg>
  );
}
export default NRPyPiIcon;
